import PropTypes from "prop-types"
import styled from "@emotion/styled"

const AbsoluteWrapper = styled.div`
  position: absolute;
  z-index: 1000;
  top: ${({ isScrollingUp }) => (isScrollingUp ? "132px" : "112px")};
  opacity: ${({ isVisible }) => (isVisible ? "1" : "0")};
  pointer-events: ${({ isVisible }) => (isVisible ? "all" : "none")};
  transition: opacity 0.7s;

  &:hover {
    color: ${({ theme }) => theme.palette.primary.main};
    border-bottom: 1px solid none;
  }
`

const HeaderAbsoluteButtons = ({ children, isVisible, isScrollingUp }) => {
  return (
    <AbsoluteWrapper
      isScrollingUp={isScrollingUp}
      className="header-absolute-buttons"
      isVisible={isVisible}
    >
      {children}
    </AbsoluteWrapper>
  )
}

HeaderAbsoluteButtons.propTypes = {
  children: PropTypes.node.isRequired,
  isScrollingUp: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired,
}

export default HeaderAbsoluteButtons
